import { render } from "./ForgotView.vue?vue&type=template&id=0f373e81&scoped=true&ts=true"
import script from "./ForgotView.vue?vue&type=script&lang=ts"
export * from "./ForgotView.vue?vue&type=script&lang=ts"

import "./ForgotView.vue?vue&type=style&index=0&id=0f373e81&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f373e81"]])

export default __exports__